export default __webpack_public_path__ + "static/media/screen7.d08c5231.jpg";